module.exports = __webpack_public_path__ + "static/media/spousal-assistance.fa716a1b.jpg";